




import { Prop, Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { resizedToSizeAttachmentUrl } from '@/helpers/resize'
import md5 from 'md5'

@Component
export default class Avatar extends Vue {
    @Prop() readonly user!: User
    @Prop({ type: Boolean, default: false }) readonly square!: boolean

    get hasAvatarUrl() {
        return this.user?.avatarUrl?.length > 0
    }

    get componentClass() {
        const classes = []

        if (!this.square) {
            classes.push('rounded-full')
        }

        return classes
    }

    get src(): string {
        if (!this.user) {
            return null
        }

        if (this.hasAvatarUrl) {
            if (this.size !== null) {
                return resizedToSizeAttachmentUrl(this.user.avatarUrl, this.size)
            }

            return this.user.avatarUrl
        }

        if (this.user && this.user.email) {
            return `https://www.gravatar.com/avatar/${md5(this.user.email)}?d=identicon`
        }

        return null
    }

    get size(): number|null {
        const classNames = this.$vnode.data.staticClass.split(' ')
        for (const className of classNames) {
            const matches = className.match(/^[hw]-(?<size>\d+)$/)
            if (matches?.length) {
                return Number.parseInt(matches.groups.size, 10)
            }
        }

        return null
    }
}
